var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_11-wow",
    "data-name": "11-wow",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7686",
    "data-name": "Ellipse 7686",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1 1)",
    fill: "#ffce52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7687",
    "data-name": "Ellipse 7687",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(13 6)",
    fill: "#273941"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7688",
    "data-name": "Ellipse 7688",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(6 6)",
    fill: "#273941"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7689",
    "data-name": "Ellipse 7689",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(14 7)",
    fill: "#141e21"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7690",
    "data-name": "Ellipse 7690",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(6 7)",
    fill: "#141e21"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7691",
    "data-name": "Ellipse 7691",
    cx: 0.5,
    cy: 1,
    rx: 0.5,
    ry: 1,
    transform: "translate(15 7)",
    fill: "#f6fafd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7692",
    "data-name": "Ellipse 7692",
    cx: 0.5,
    cy: 1,
    rx: 0.5,
    ry: 1,
    transform: "translate(7 7)",
    fill: "#f6fafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15386",
    "data-name": "Path 15386",
    d: "M32.453,7.726H31.59a.863.863,0,0,0-1.726,0H29a1.726,1.726,0,1,1,3.453,0Z",
    transform: "translate(-15.915 -2.842)",
    fill: "#273941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15387",
    "data-name": "Path 15387",
    d: "M14.453,7.726H13.59a.863.863,0,1,0-1.726,0H11a1.726,1.726,0,0,1,3.453,0Z",
    transform: "translate(-5.684 -2.842)",
    fill: "#273941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15388",
    "data-name": "Path 15388",
    d: "M10.941,2.336c5.244,0,9.5,3.672,9.5,8.2h.421a9.927,9.927,0,0,0-19.832,0h.421c0-4.529,4.251-8.2,9.5-8.2Z",
    transform: "translate(-0.014 -0.041)",
    fill: "#ffe369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15389",
    "data-name": "Path 15389",
    d: "M20.422,23c0,4.529-4.251,8.2-9.5,8.2s-9.5-3.672-9.5-8.2H1.011C1,23.143,1,23.287,1,23.432a9.927,9.927,0,0,0,19.854,0c0-.145,0-.288-.011-.432Z",
    transform: "translate(0 -12.505)",
    fill: "#ffb32b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13572",
    "data-name": "Group 13572",
    transform: "translate(11.812 1.095)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7693",
    "data-name": "Ellipse 7693",
    cx: 0.356,
    cy: 0.495,
    rx: 0.356,
    ry: 0.495,
    transform: "translate(2.83 1.538) rotate(-45)",
    fill: "#f6fafd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7694",
    "data-name": "Ellipse 7694",
    cx: 0.178,
    cy: 0.248,
    rx: 0.178,
    ry: 0.248,
    transform: "translate(0 0.939) rotate(-45)",
    fill: "#f6fafd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7695",
    "data-name": "Ellipse 7695",
    cx: 0.712,
    cy: 0.991,
    rx: 0.712,
    ry: 0.991,
    transform: "translate(0.502 1.007) rotate(-45)",
    fill: "#f6fafd"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7696",
    "data-name": "Ellipse 7696",
    cx: 2,
    cy: 4,
    rx: 2,
    ry: 4,
    transform: "translate(9 11)",
    fill: "#273941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15390",
    "data-name": "Path 15390",
    d: "M20.826,38.453c1.1,0,2.033-1.025,2.41-2.47a3.446,3.446,0,0,0-4.82,0C18.793,37.428,19.729,38.453,20.826,38.453Z",
    transform: "translate(-9.899 -19.325)",
    fill: "#ae2d4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15391",
    "data-name": "Path 15391",
    d: "M20.59,38.453c-1.333,0-2.429-1.511-2.573-3.453-.01.142-.017.286-.017.432,0,2.145,1.159,3.884,2.59,3.884s2.59-1.739,2.59-3.884c0-.146-.006-.29-.017-.432C23.019,36.942,21.922,38.453,20.59,38.453Z",
    transform: "translate(-9.663 -19.326)",
    fill: "#ffb32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15392",
    "data-name": "Path 15392",
    d: "M20.59,25.863c1.333,0,2.429,1.511,2.573,3.453.01-.142.017-.286.017-.432,0-2.145-1.159-3.884-2.59-3.884S18,26.739,18,28.884c0,.146.006.29.017.432C18.16,27.374,19.257,25.863,20.59,25.863Z",
    transform: "translate(-9.663 -13.642)",
    fill: "#141e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15393",
    "data-name": "Path 15393",
    d: "M20.826,38.613a2.566,2.566,0,0,1-2.18-1.813c-.079.065-.156.133-.23.2.377,1.447,1.313,2.472,2.41,2.472s2.033-1.025,2.41-2.47c-.073-.072-.15-.139-.23-.2A2.567,2.567,0,0,1,20.826,38.613Z",
    transform: "translate(-9.899 -20.349)",
    fill: "#8a293d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWow);
export default __webpack_public_path__ + "static/media/wow.70408469db75f74343ee5c222a779eb0.svg";
export { ForwardRef as ReactComponent };